<app-user-header></app-user-header>

@if(isCandidatevalid){

<nav class="container-fluid pt-3 pb-3 bd-navbar sub-header">
  <div class="row">
    <div class="col">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb" style="cursor: pointer">
          <!--<li class="breadcrumb-item" routerLink="/dashboard"><a >Home</a></li>-->
          <li class="breadcrumb-item active" aria-current="page">
            <a>
              <i
                class="material-icons green align-middle"
                style="cursor: pointer"
                (click)="backButton()"
                >keyboard_arrow_left</i
              >
              Candidate List</a
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            <a (click)="assessmentDashboard()">{{
              assessmentDetails?.candidateDetails?.profileInfo
            }}</a>
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-5">
      <div>
        Batch Name:
        <span class="criteria-title">{{ assessmentDetails?.linkName }}</span>
      </div>
      <!-- <div>Assessment Status: {{ assessmentDetails?.assessmentStatus }}</div> -->
    </div>

    <div class="col-6"></div>

    <!-- <div class="col-1">
      <button
        (click)="completeEvaluation()"
        type="button"
        class="btn btn-primary"
      >
        Save for later
      </button>
    </div> -->

    <!-- matTooltip="Please evaluate all questions in all sections to enable submit evaluation."
        [disabled]="true"
        [matTooltipDisabled]="false" -->
    <div class="col-1">
      @if(!isAssessmentEmpty){
      <button
        (click)="completeEvaluation()"
        type="button"
        class="btn btn-primary"
      >
        Submit Evaluation
      </button>
      }
    </div>
  </div>

  <div *ngIf="safeHtml" class="mt-2">
    <div [innerHTML]="safeHtml"></div>
  </div>

  <div class="d-flex justify-content-between mt-3">
    <div>
      <div class="btn-group">
        <div class="form-group d-flex align-items-center">
          <label for="difficultylevel" class="mb-0 mr-2">Section:</label>

          <select
            class="form-control w-auto"
            id="difficultylevel"
            name="difficultylevel"
            [(ngModel)]="selectedSection"
            (ngModelChange)="onSectionChangeView($event)"
          >
            <option
              *ngFor="
                let section of assessmentDetails?.candidateEvaluationDetails
              "
              [value]="section.sectionName"
            >
              {{ section.sectionName }}
            </option>
          </select>
        </div>
      </div>
    </div>

    @if(QuestionList?.length > 0){
    <div class="">
      <div class="">
        <div class="pagination">
          Question:
          <button
            [disabled]="QuestionList?.length <= 10"
            (click)="prev()"
            class="qbox"
          >
            <i class="fa-solid fa-angles-left"></i>
          </button>

          <div
            *ngFor="let q of visibleQuestions; let i = index"
            class="qbox page-number"
            (click)="onSelectQuestionPage(i)"
            [ngClass]="getQuestionClass(q, i)"
          >
            {{ i + 1 }}
          </div>

          <button
            [disabled]="QuestionList?.length <= 10"
            (click)="next()"
            class="qbox"
          >
            <i class="fa-solid fa-angles-right"></i>
          </button>

          <i
            class="fa-solid fa-circle-info EditIcons-hover"
            [matMenuTriggerFor]="menu"
            #trigger="matMenuTrigger"
            matTooltip="View evaluation status guide"
          ></i>

          <mat-menu class="mt-4" #menu="matMenu">
            <div
              class="card-menu"
              (mouseenter)="trigger.openMenu()"
              (mouseleave)="trigger.closeMenu()"
            >
              <div>
                <div class="card p-3">
                  <div class="card-body card-bg">
                    <h6 class="mb-3 fw-semibold">Evaluation Status Guide</h6>

                    <div class="d-flex flex-column gap-3">
                      <div class="d-flex align-items-center gap-2">
                        <span class="status-dot status-blue"></span>
                        <strong>Current Selected</strong>
                      </div>

                      <div class="d-flex align-items-center gap-2">
                        <span class="status-dot status-yellow"></span>
                        <strong>Marked for Review</strong>
                      </div>

                      <div class="d-flex align-items-center gap-2">
                        <span class="status-dot status-green"></span>
                        <strong>Marked as Evaluated</strong>
                      </div>

                      <div class="d-flex align-items-center gap-2">
                        <span class="status-dot status-gray"></span>
                        <strong>Not Started</strong>
                      </div>

                      <!--   <div class="d-flex align-items-center gap-2">
                        <span class="status-dot status-review"></span>
                        <strong>Marked for Review</strong>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </mat-menu>
        </div>
      </div>
    </div>
    }
  </div>
</nav>

<div class="main-div-assessment container-fluid bg-white pt-5 pb-5 mt-5">
  <div class="row no-gutters">
    <!-- <div class="col-3" style="height: 66vh">
      <div class="section-details container-fluid bg1 pb-0">
        <div *ngFor="let item of sections; let i = index">
          <div class="my-3">
            <div class="row ml-2">
              <div>
                {{ i + 1 }}. {{ item.sectionName }}
                <input class="ml-2" type="checkbox" />
              </div>
            </div>
          </div>

          <div
            class="ml-3"
            *ngFor="let question of item.questions; let j = index"
          >
            <div class="my-2">
              <div class="row">
                <div class="col-10">{{ j + 1 }}. {{ question.question }}</div>
                <div class="col-2">
                  <input type="checkbox" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="col-12">
      @if(QuestionList?.length > 0){
      <div class="row">
        <!-- Question Section -->
        <div class="col-8" style="height: 54vh; overflow-y: scroll">
          <div class="card p-3">
            <div class="card-body card-bg">
              <div class="d-flex justify-content-between">
                <h4>Question - {{ selectedQuestionId + 1 }}</h4>

                <div class="header-controls">
                  <!-- <label class="gap-check">
                    <input
                      type="checkbox"
                      class="q-check"
                      [checked]="isChecked2"
                      (change)="onCheckChange2($event)"
                    />
                    <span>Pause</span>
                  </label> -->

                  <label class="gap-check EditIcons-hover">
                    <input
                      type="checkbox"
                      class="q-check"
                      [(ngModel)]="selectedQuestion.isMarkedForReview"
                      (change)="onReviewChange()"
                    />
                    <span>Mark for Review</span>
                  </label>

                  <label class="control-item finish EditIcons-hover">
                    <input
                      type="checkbox"
                      class="q-check"
                      [(ngModel)]="selectedQuestion.isMarkedAsEvaluated"
                      (change)="onEvaluatedChange()"
                      [disabled]="
                        getAnsweredRubricCount() !=
                          selectedQuestion?.rubricDetails.length ||
                        (selectedQuestion.rubricDetails.length == 0 &&
                          selectedQuestion.adminScore == '')
                      "
                      matTooltip="Please complete all rubric criteria to enable Mark as Evaluated"
                      [matTooltipDisabled]="
                        getAnsweredRubricCount() ==
                        selectedQuestion.rubricDetails.length
                      "
                    />
                    <span>Mark as Evaluated</span>
                  </label>
                </div>
              </div>

              <div>
                <span [innerHTML]="cleanHtml(selectedQuestion.question)"></span>
              </div>

              <!-- <div class="mb-3 ml-3 mt-1">
                <ng-container
                  *ngIf="
                    selectedQuestion.questionAttachedMedias &&
                    selectedQuestion.questionAttachedMedias.length > 0
                  "
                >
                  <div
                    [ngClass]="{
                      'scroll-container':
                        selectedQuestion.questionAttachedMedias.length === 6 &&
                        selectedRenderedOption === 'all'
                    }"
                  > -->
              <div *ngIf="selectedQuestion?.questionAttachedMedias?.length">
                <div #viewerContainer class="media-container">
                  <div
                    *ngFor="
                      let media of selectedQuestion.questionAttachedMedias
                    "
                    class="media-item"
                  >
                    <!-- ✅ IMAGE -->
                    <img
                      *ngIf="media.fileType.startsWith('images')"
                      [src]="media.location"
                      class="media-content"
                    />

                    <!-- ✅ VIDEO -->
                    <video
                      *ngIf="media.fileType.startsWith('video')"
                      [src]="media.location"
                      controls
                      class="media-content"
                    ></video>
                  </div>
                </div>
              </div>

              <div class="row mb-2">
                <!-- <div
                        *ngIf="
                          selectedQuestion.questionAttachedMedias.length === 1;
                          else others
                        "
                        [ngClass]="{
                          'col-12':
                            selectedQuestion.questionAttachedMedias.length === 1
                        }"
                      > -->
                <!-- <div class="media-container">
                  <div
                    *ngFor="
                      let media of selectedQuestion.questionAttachedMedias
                    "
                    class="media-item"
                  >
               
                    <img
                      *ngIf="media.fileType.startsWith('images')"
                      [src]="media.location"
                      class="media-content preview-img"
                      matTooltip="Click to preview"
                      (click)="openViewer(media.location)"
                    />

                  
                    <video
                      *ngIf="media.fileType.startsWith('video')"
                      [src]="media.location"
                      controls
                      class="media-content"
                    ></video>
                  </div>
                </div> -->
                <!-- </div> -->
                <!-- <ng-template #others>
                        <div
                          *ngFor="
                            let media of selectedQuestion.questionAttachedMedias;
                            let k = index
                          "
                          class="media-item"
                          [ngClass]="{
                            'col-12': selectedRenderedOption === '1',
                            'col-6': selectedRenderedOption === '2',
                            'col-4': selectedRenderedOption === '3',
                            'col-3': selectedRenderedOption === '4',
                            'col-2': selectedRenderedOption === '5',
                            'media-col-1': selectedRenderedOption === 'all'
                          }"
                        >
                          <div *ngIf="media.fileType.startsWith('images')">
                            <img
                              [src]="media.location"
                              alt="Image Preview"
                              style="width: 160px; height: 130px"
                              class="mt-2 mr-1"
                            />
                          </div>
                          <div
                            *ngIf="media.fileType.startsWith('video')"
                            #myVideo
                          >
                            <video
                              [src]="media.location"
                              controls
                              disablePictureInPicture
                              style="width: 160px; height: 130px"
                              controlslist="nodownload noplaybackrate nofullscreen"
                              class="mt-2 mr-1"
                            ></video>
                          </div>
                        </div>
                      </ng-template> -->
              </div>
              <!-- </div>
                </ng-container>
              </div> -->

              <div
                style="
                  width: 100%;
                  padding: 6px;
                  border: 1px solid black;
                  height: 40vh;
                  overflow-y: scroll;
                "
              >
                {{ selectedQuestion?.userGivenAns[0] }}
                <!-- <textarea
                  rows="15"
                  style="width: 100%; padding: 6px"
                  [value]="essayText"
                ></textarea> -->
              </div>

              <!-- <div *ngIf="selectedQuestion?.attachmentFiles.length > 0">
                <h6>Attachments</h6>
                <div *ngFor="let doc of selectedQuestion?.attachmentFiles">
                  <div (click)="openUrl(doc)">{{ doc.fileName }}</div>
                </div>
              </div> -->

              <div
                class="attachment-container"
                *ngIf="selectedQuestion?.attachmentFiles?.length > 0"
              >
                <div class="attachment-header">
                  <h6>📎 Attachments</h6>
                  <span>
                    {{ selectedQuestion.attachmentFiles.length }} files
                  </span>
                </div>

                <div
                  class="attachment-item"
                  *ngFor="let doc of selectedQuestion.attachmentFiles"
                  (click)="openUrl(doc)"
                >
                  <div class="file-icon">📄</div>

                  <div class="file-details" title="Click to Open Document">
                    <div class="file-name">
                      {{ doc.fileName }}
                      <i class="fa-solid fa-eye open-icon"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Rubric Section -->
        <div class="col-4" style="height: 54vh; overflow-y: scroll">
          <div class="card p-1">
            <div class="card-body card-bg">
              <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
                <mat-tab label="Evaluation">
                  @if(selectedQuestion.rubricDetails.length>0) {
                  <div class="d-flex justify-content-between mt-2">
                    <h4>Rubric Evaluation</h4>
                    <h4>
                      <span class="batch-stats">
                        {{ getAnsweredRubricCount() }} /
                        {{ selectedQuestion.rubricDetails.length }}</span
                      >
                    </h4>
                  </div>

                  <div
                    class="mt-3"
                    *ngFor="
                      let rubricdata of selectedQuestion.rubricDetails;
                      let r = index
                    "
                  >
                    <div class="d-flex justify-content-between">
                      <div class="criteria-title">
                        {{ rubricdata.rubricLabel }}
                      </div>
                      <div>
                        <h6>
                          <span class="batch-stats">
                            {{
                              getAnsweredCount(
                                selectedQuestion.rubricDetails[r].criteria
                              )
                            }}
                            / {{ rubricdata.criteria.length }}</span
                          >
                        </h6>
                      </div>
                    </div>

                    <div
                      *ngFor="
                        let criteriaData of rubricdata.criteria;
                        let c = index
                      "
                      class="criteria-card"
                    >
                      <div>
                        <div class="criteria-title">
                          {{ c + 1 }}.{{ criteriaData?.criteriaLabel }}
                        </div>

                        <div>
                          {{ criteriaData?.criteriaDescription }}
                        </div>

                        <!-- <span [ngClass]="getStatusClass2(2, 2)">
                      <i class="fa-solid fa-spinner"></i>
                      <i class="fa-solid fa-circle-check"></i>
                    </span> -->
                      </div>

                      <div
                        *ngFor="
                          let point of criteriaData.scaleExplanations;
                          let p = index
                        "
                        class="criteria-point"
                      >
                        <label>
                          <input
                            type="radio"
                            [name]="'criteria-' + r + '-' + c"
                            [value]="p"
                            [checked]="
                              selectedQuestion.rubricDetails[r].criteria[
                                c
                              ].scoreGiven.toString() === p.toString()
                            "
                            (change)="setScore(r, c, p, $event)"
                          />{{ p }} - {{ point }}
                        </label>
                      </div>
                    </div>
                  </div>
                  } @else {
                  <div class="d-flex mt-3">
                    <div class="mt-2 mr-2">Score :</div>
                    <input
                      type="text"
                      class="form-control"
                      style="width: 150px"
                      appOnlyNumber
                      [(ngModel)]="selectedQuestion.adminScore"
                    />
                    <span class="mt-2 mr-2 ml-2" style="font-size: 18px">
                      / {{ selectedQuestion.score }}</span
                    >
                  </div>

                  }
                </mat-tab>
                <mat-tab label="Remarks">
                  <!-- <div class="row mt-3">
                    <div class="col-12 form-group">
                      <label for="question">Remarks</label> -->
                  <textarea
                    rows="12"
                    class="form-control mt-3"
                    id="formGroupExampleI"
                    placeholder="Enter Remarks"
                    style="padding: 10px"
                    [(ngModel)]="Questionremarks"
                  ></textarea>

                  <div class="d-flex justify-content-end mt-5">
                    <button
                      type="button"
                      class="btn btn-primary"
                      (click)="addRemarks()"
                    >
                      Add Remark
                    </button>
                  </div>
                  <!-- </div>
                  </div> -->
                </mat-tab>
              </mat-tab-group>
            </div>
          </div>
        </div>
      </div>
      } @else{
      <div *ngIf="QuestionList.length == 0" style="text-align: center">
        <div class="empty-box my-3">
          <div class="empty-content">
            <div class="empty-icon">🗂️</div>
            <h5>
              The candidate has not answered any questions in this section.
            </h5>
          </div>
        </div>
      </div>
      }

      <div class="d-flex justify-content-center mt-5">
        <button
          [disabled]="!(selectedQuestionId || selectedIndex)"
          type="button"
          class="btn btn-cancel"
          (click)="prev()"
        >
          Previous
        </button>

        <button
          type="button"
          class="btn btn-primary"
          [disabled]="
            (assessmentDetails.candidateEvaluationDetails.length - 1 ==
              selectedIndex &&
              selectedQuestionId == QuestionList?.length - 1) ||
            (assessmentDetails.candidateEvaluationDetails.length - 1 ==
              selectedIndex &&
              QuestionList?.length == 0)
          "
          (click)="next()"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</div>
} @else{
<div class="error-block">
  <app-error-page></app-error-page>
</div>

}
